import { ModalM } from "@common/components/modal/ModalM"
import TextM from "@common/components/text/TextM"
import { theme } from "@common/theme/theme"
import FAQComponent from "@common/components/FAQ/FAQComponent"
import * as WebBrowser from "expo-web-browser"
import React, { useState } from "react"
import { ScrollView, TouchableOpacity, View } from "react-native"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"
import { connect } from "react-redux"
import { IS_WEB } from "../../common/utils/mobileUtils"

const WHATSAPP_URL = "https://wa.me/message/FCOBQ6PCPMBJC1"

const SubscriptionHelpButton = ({ faqs, variant = "icon" }) => {
    const [showModal, setShowModal] = useState(false)
    const [modalView, setModalView] = useState("menu") // 'menu' | 'faq'

    const hasFaqs = faqs && faqs.length > 0

    const handleDismiss = () => {
        setShowModal(false)
        setModalView("menu")
    }

    const handleWhatsAppOpen = () => {
        handleDismiss()
        if (IS_WEB) {
            window.open(WHATSAPP_URL)
        } else {
            WebBrowser.openBrowserAsync(WHATSAPP_URL)
        }
    }

    return (
        <>
            {variant === "icon" ? (
                <TouchableOpacity
                    onPress={() => setShowModal(true)}
                    style={{
                        width: 36,
                        height: 36,
                        borderRadius: 18,
                        backgroundColor: theme.colors.primary,
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <FontAwesome5 name="question" size={16} color="#fff" solid />
                </TouchableOpacity>
            ) : (
                <TouchableOpacity
                    onPress={() => setShowModal(true)}
                    style={{
                        flexDirection: "row",
                        alignItems: "center",
                        alignSelf: "center",
                        paddingVertical: 10,
                        paddingHorizontal: 20,
                        marginBottom: 20,
                        borderRadius: 20,
                        borderWidth: 1,
                        borderColor: theme.colors.primary,
                    }}
                >
                    <FontAwesome5
                        name="question-circle"
                        size={16}
                        color={theme.colors.primary}
                        style={{ marginRight: 8 }}
                    />
                    <TextM fontWeight="Medium" color={theme.colors.primary}>
                        Une question ?
                    </TextM>
                </TouchableOpacity>
            )}

            <ModalM
                visible={showModal}
                onDismiss={handleDismiss}
                style={{ padding: 20 }}
            >
                {modalView === "menu" ? (
                    <>
                        <TextM
                            fontWeight="Bold"
                            fontSize={18}
                            style={{ marginBottom: 20, textAlign: "center" }}
                        >
                            Besoin d'aide ?
                        </TextM>

                        {hasFaqs && (
                            <TouchableOpacity
                                onPress={() => setModalView("faq")}
                                style={{
                                    flexDirection: "row",
                                    alignItems: "center",
                                    paddingVertical: 15,
                                    borderBottomWidth: 1,
                                    borderBottomColor: theme.colors.lightMore,
                                }}
                            >
                                <FontAwesome5
                                    name="question-circle"
                                    size={20}
                                    color={theme.colors.primary}
                                    style={{ marginRight: 15, width: 24 }}
                                />
                                <TextM fontWeight="Medium" fontSize={16}>
                                    Questions fréquentes
                                </TextM>
                            </TouchableOpacity>
                        )}

                        <TouchableOpacity
                            onPress={handleWhatsAppOpen}
                            style={{
                                flexDirection: "row",
                                alignItems: "center",
                                paddingVertical: 15,
                                borderBottomWidth: 1,
                                borderBottomColor: theme.colors.lightMore,
                            }}
                        >
                            <FontAwesome5
                                name="whatsapp"
                                size={20}
                                color={theme.colors.success}
                                style={{ marginRight: 15, width: 24 }}
                            />
                            <TextM fontWeight="Medium" fontSize={16}>
                                Nous écrire par WhatsApp
                            </TextM>
                        </TouchableOpacity>
                    </>
                ) : (
                    <>
                        <View
                            style={{
                                flexDirection: "row",
                                alignItems: "center",
                                marginBottom: 10,
                            }}
                        >
                            <TouchableOpacity
                                onPress={() => setModalView("menu")}
                                style={{ marginRight: 10 }}
                            >
                                <FontAwesome5
                                    name="arrow-left"
                                    size={18}
                                    color={theme.colors.primary}
                                />
                            </TouchableOpacity>
                            <TextM fontWeight="Bold" fontSize={18}>
                                Questions fréquentes
                            </TextM>
                        </View>
                        <ScrollView
                            style={{ maxHeight: 600 }}
                            showsVerticalScrollIndicator={false}
                        >
                            <FAQComponent faqs={faqs} />
                        </ScrollView>
                    </>
                )}
            </ModalM>
        </>
    )
}

const mapStateToProps = (state) => ({
    faqs: state.data.formData?.faq,
})

export default connect(mapStateToProps)(SubscriptionHelpButton)
